import { computed, ComputedRef } from 'vue';
import type { Field } from '@ilteducation/content-search';

const useLMGFilterFields = (): ComputedRef<Field[]> =>
  computed(() => [
    {
      aggregate: true,
      aggregationKey: 'categories',
      kind: 'subject',
      label: 'label_subjects',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'areas',
      label: 'label_areas',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'categories',
      kind: 'grade',
      label: 'label_grades',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'languages.secondaryLanguage',
      label: 'label_languages_list',
      item_label_prefix: 'languages',
      type: 'list',
    },
  ]);

export default useLMGFilterFields;
